module.exports = __webpack_public_path__ + "img/file-cover.7f6e25c7.jpg";